import React from 'react'

import './EasyBuy.scss'

const images = {
  hero: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1400&q=85',
  shopping:
    'https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=85',
  products:
    'https://images.unsplash.com/photo-1607082349566-187342175e2f?auto=format&fit=crop&w=1200&q=85',
  business:
    'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=85'
}

export default function EasyBuy() {
  return (
    <div className="easybuy-page">
      {/* HERO */}
      <section className="easybuy-hero">
        <div className="easybuy-container">
          <div className="hero-content">
            <span className="hero-badge">
              <i className="bi bi-bag-check-fill"></i>
              EasyBuy
            </span>

            <h1>
              Compra fácil.
              <span> Compra mejor.</span>
            </h1>

            <p>
              Una plataforma de comercio electrónico pensada para conectar
              compradores con productos y negocios en un solo lugar.
            </p>

            <div className="hero-actions">
              <a
                href="https://www.easybuyshopec.com/home"
                target="_blank"
                rel="noopener noreferrer"
                className="easybuy-btn primary"
              >
                Comprar ahora
                <i className="bi bi-arrow-up-right"></i>
              </a>

              <a href="#negocios" className="easybuy-btn secondary">
                Tengo un negocio
                <i className="bi bi-shop"></i>
              </a>
            </div>

            <div className="hero-trust">
              <div>
                <i className="bi bi-check-circle-fill"></i>
                Compra online
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Catálogo digital
              </div>

              <div>
                <i className="bi bi-check-circle-fill"></i>
                Checkout seguro
              </div>
            </div>
          </div>

          <div className="hero-visual">
            <div className="hero-image-card">
              <img src={images.hero} alt="EasyBuy" />
            </div>

            <div className="floating-card cart-card">
              <div className="floating-icon">
                <i className="bi bi-cart-check"></i>
              </div>

              <div>
                <strong>Compra realizada</strong>
                <span>Pedido confirmado</span>
              </div>

              <i className="bi bi-check-circle-fill success"></i>
            </div>

            <div className="floating-card product-card-float">
              <i className="bi bi-box-seam"></i>
              <span>Encuentra tus productos</span>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="easybuy-intro">
        <div className="easybuy-container">
          <div className="section-heading centered">
            <span>UNA PLATAFORMA, DOS EXPERIENCIAS</span>

            <h2>
              Todo lo que necesitas para
              <strong> comprar y vender online.</strong>
            </h2>

            <p>
              EasyBuy reúne una experiencia de compra sencilla para los clientes
              y herramientas de administración para los negocios.
            </p>
          </div>

          <div className="audience-grid">
            {/* CLIENTE */}
            <article className="audience-card">
              <div className="audience-image">
                <img src={images.shopping} alt="Comprar en EasyBuy" />
              </div>

              <div className="audience-content">
                <span className="small-label">PARA COMPRADORES</span>

                <h3>Encuentra lo que buscas.</h3>

                <p>
                  Explora productos, revisa ofertas, agrega artículos al carrito
                  y completa tu compra desde una experiencia sencilla.
                </p>

                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Explora categorías y productos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Encuentra ofertas
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Agrega productos al carrito
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Consulta el resumen de tu compra
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Selecciona el método de envío
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestiona tus pedidos
                  </li>
                </ul>

                <a
                  href="https://www.easybuyshopec.com/home"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link"
                >
                  Visitar EasyBuy
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </article>

            {/* NEGOCIO */}
            <article className="audience-card" id="negocios">
              <div className="audience-image">
                <img src={images.business} alt="EasyBuy para negocios" />
              </div>

              <div className="audience-content">
                <span className="small-label">PARA NEGOCIOS</span>

                <h3>Tu tienda online, bajo control.</h3>

                <p>
                  Administra productos, establecimientos, clientes y pedidos
                  desde una plataforma diseñada para simplificar tu operación.
                </p>

                <ul>
                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Administra tus productos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestiona establecimientos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Controla tus pedidos
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Administra clientes
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Gestiona promociones y ofertas
                  </li>

                  <li>
                    <i className="bi bi-check-circle-fill"></i>
                    Consulta la operación de tu tienda
                  </li>
                </ul>

                <a
                  href="https://admin.easybuyshopec.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link"
                >
                  Ir al administrador
                  <i className="bi bi-arrow-up-right"></i>
                </a>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* SHOPPING EXPERIENCE */}
      <section className="feature-section">
        <div className="easybuy-container feature-layout">
          <div className="feature-content">
            <span className="section-label">EXPERIENCIA DE COMPRA</span>

            <h2>
              Comprar online puede ser
              <strong> así de simple.</strong>
            </h2>

            <p>
              EasyBuy acompaña al comprador desde el descubrimiento del producto
              hasta la confirmación de su pedido.
            </p>

            <div className="feature-list">
              <div>
                <span>01</span>

                <div>
                  <h4>Explora</h4>

                  <p>Descubre categorías, productos y ofertas disponibles.</p>
                </div>
              </div>

              <div>
                <span>02</span>

                <div>
                  <h4>Selecciona</h4>

                  <p>
                    Revisa los productos y agrega lo que necesitas al carrito.
                  </p>
                </div>
              </div>

              <div>
                <span>03</span>

                <div>
                  <h4>Compra</h4>

                  <p>Revisa tu pedido, impuestos y opciones de envío.</p>
                </div>
              </div>

              <div>
                <span>04</span>

                <div>
                  <h4>Recibe</h4>

                  <p>
                    Completa tu compra y realiza el seguimiento de tu pedido.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="feature-visual">
            <div className="shopping-image">
              <img src={images.products} alt="Productos EasyBuy" />
            </div>

            <div className="feature-stat">
              <i className="bi bi-cart-check-fill"></i>

              <div>
                <strong>Tu carrito, siempre listo</strong>
                <span>Compra de forma rápida y sencilla</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features-section">
        <div className="easybuy-container">
          <div className="section-heading centered">
            <span>TODO EN UN SOLO LUGAR</span>

            <h2>
              Herramientas para una
              <strong> experiencia completa.</strong>
            </h2>

            <p>
              EasyBuy integra las principales funciones necesarias para una
              experiencia de comercio electrónico moderna.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-grid"></i>
              </div>

              <h3>Catálogo</h3>

              <p>
                Organiza y presenta tus productos mediante categorías y
                colecciones.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-tags"></i>
              </div>

              <h3>Ofertas</h3>

              <p>
                Destaca productos y promociones para atraer a tus compradores.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-cart3"></i>
              </div>

              <h3>Carrito</h3>

              <p>
                Permite a tus clientes organizar sus productos antes de comprar.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-credit-card"></i>
              </div>

              <h3>Checkout</h3>

              <p>Un proceso de compra claro con resumen, impuestos y envío.</p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-box-seam"></i>
              </div>

              <h3>Pedidos</h3>

              <p>
                Gestiona y consulta los pedidos realizados en la plataforma.
              </p>
            </div>

            <div className="feature-box">
              <div className="feature-icon">
                <i className="bi bi-shop"></i>
              </div>

              <h3>Establecimientos</h3>

              <p>Administra los establecimientos asociados a la operación.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ADMIN */}
      <section className="admin-section">
        <div className="easybuy-container">
          <div className="admin-banner">
            <div className="admin-content">
              <span>PARA ADMINISTRADORES</span>

              <h2>
                Administra tu operación
                <strong> desde un solo lugar.</strong>
              </h2>

              <p>
                El panel administrativo de EasyBuy permite gestionar los
                elementos principales de tu tienda y mantener el control de la
                operación.
              </p>

              <a
                href="https://admin.easybuyshopec.com"
                target="_blank"
                rel="noopener noreferrer"
                className="easybuy-btn white"
              >
                Acceder al administrador
                <i className="bi bi-arrow-up-right"></i>
              </a>
            </div>

            <div className="admin-decoration">
              <i className="bi bi-speedometer2"></i>

              <div className="mini-panel">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="categories-section">
        <div className="easybuy-container">
          <div className="section-heading centered">
            <span>UNA TIENDA, MUCHAS CATEGORÍAS</span>

            <h2>
              Descubre productos para
              <strong> cada necesidad.</strong>
            </h2>

            <p>
              Desde tecnología y moda hasta hogar, entretenimiento y mucho más.
            </p>
          </div>

          <div className="categories-grid">
            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-tablet"></i>
              </div>

              <h3>Tecnología</h3>

              <p>Tablets, computadores, accesorios y dispositivos.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-person"></i>
              </div>

              <h3>Moda</h3>

              <p>Ropa, accesorios y productos para toda la familia.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-house"></i>
              </div>

              <h3>Hogar</h3>

              <p>Productos para hacer tu hogar más práctico.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-controller"></i>
              </div>

              <h3>Entretenimiento</h3>

              <p>Juguetes, videojuegos y productos para disfrutar.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-bicycle"></i>
              </div>

              <h3>Deportes</h3>

              <p>Equipamiento y accesorios deportivos.</p>
            </div>

            <div className="category-item">
              <div className="category-icon">
                <i className="bi bi-three-dots"></i>
              </div>

              <h3>Mucho más</h3>

              <p>Explora todas las categorías disponibles.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="easybuy-cta">
        <div className="easybuy-container">
          <div>
            <span>EASYBUY</span>

            <h2>
              Todo lo que buscas.
              <br />
              En un solo lugar.
            </h2>

            <p>
              Descubre productos, encuentra ofertas y disfruta una experiencia
              de compra sencilla.
            </p>
          </div>

          <a
            href="https://www.easybuyshopec.com/home"
            target="_blank"
            rel="noopener noreferrer"
            className="easybuy-btn white"
          >
            Visitar EasyBuy
            <i className="bi bi-arrow-up-right"></i>
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="easybuy-footer">
        <div className="easybuy-container footer-content">
          <div className="footer-brand">
            <div className="brand-logo">
              <span>E</span>
              <strong>EasyBuy</strong>
            </div>

            <p>
              Una plataforma de comercio electrónico desarrollada por SIGMATEC.
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>EasyBuy</h4>

              <a href="#negocios">Para negocios</a>

              <a
                href="https://www.easybuyshopec.com/home"
                target="_blank"
                rel="noopener noreferrer"
              >
                Comprar
              </a>

              <a
                href="https://admin.easybuyshopec.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Administración
              </a>
            </div>

            <div>
              <h4>Información</h4>

              <a href={global.TERM_CONDITION}>Términos y condiciones</a>

              <a href={global.DIGITAL_DATA}>Privacidad</a>

              <a href={global.TEST_REQUEST}>Contáctanos</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="easybuy-container">
            <span>
              © {new Date().getFullYear()} SIGMATEC. Todos los derechos
              reservados.
            </span>

            <span>EasyBuy</span>
          </div>
        </div>
      </footer>
    </div>
  )
}
